/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Community_Shipped_InInputs */

const en_us2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Since version ${i?.version}`)
};

const pt_br2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde a versão ${i?.version}`)
};

const es_419_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde la versión ${i?.version}`)
};

const pt_pt2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde a versão ${i?.version}`)
};

const fr_fr2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Depuis la version ${i?.version}`)
};

const de_de2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seit Version ${i?.version}`)
};

const it_it2_community_shipped_in = /** @type {(inputs: Community_Shipped_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dalla versione ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Since version {version}" |
*
* @param {Community_Shipped_InInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_shipped_in = /** @type {((inputs: Community_Shipped_InInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Shipped_InInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_shipped_in(inputs)
	if (locale === "es-419") return es_419_community_shipped_in(inputs)
	if (locale === "pt-PT") return pt_pt2_community_shipped_in(inputs)
	if (locale === "fr-FR") return fr_fr2_community_shipped_in(inputs)
	if (locale === "de-DE") return de_de2_community_shipped_in(inputs)
	if (locale === "it-IT") return it_it2_community_shipped_in(inputs)
	return en_us2_community_shipped_in(inputs)
});
export { community_shipped_in as "community.shipped_in" }